// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2B3bt","filesListContainer":"PosDisputesFiles_filesListContainer__2hWuQ","filesButton":"PosDisputesFiles_filesButton__2272b"};